import React, { useState, useEffect } from 'react'
import { Table, Panel } from 'rsuite'
import { Icon, IconButton, ButtonGroup, Modal, Button } from 'rsuite'

export default function TagetDep6Table({ schema, handleDelete, handleEdit, isEdit, ...props }) {
  const { Column, HeaderCell, Cell } = Table

  const [isdelete, setIsdelete] = useState(false)
  const [deleteId, setDeleteId] = useState()

  return (
    <Panel eventKey={2} bodyFill>
      <div>
        <Table
          rowKey="id"
          height={400}
          autoHeight={schema?.taget?.values?.length <= 5}
          wordWrap={true}
          data={schema?.taget?.values || []}
        >
          <Column minWidth={200} width={200} flexGrow={1}>
            <HeaderCell>{schema.targetValue.label}</HeaderCell>
            <Cell dataKey={'targetName'} />
          </Column>

          <Column width={120} align="right">
            <HeaderCell align="center">{schema.targetTotal.label}</HeaderCell>
            <Cell dataKey={'targetTotal'} />
          </Column>

          <Column width={150} align="center">
            <HeaderCell>{schema.targetUnit.label}</HeaderCell>
            <Cell dataKey={'targetUnit'} />
          </Column>

          {isEdit && (
            <Column width={100} align="center" fixed="right">
              <HeaderCell></HeaderCell>

              <Cell>
                {(rowData) => {
                  return (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-edit"
                        icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                        onClick={(e) => {
                          handleEdit(rowData)
                        }}
                      >
                        แก้ไข
                      </IconButton>
                      {rowData.enableDeleted && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          icon={<Icon icon="trash-o" className="bt-gost-icon-radius-cancel" />}
                          onClick={(e) => {
                            setIsdelete(true)
                            setDeleteId(rowData.id)
                          }}
                        >
                          ลบ
                        </IconButton>
                      )}
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>
      </div>

      <Modal
        show={isdelete}
        onHide={(e) => {
          setIsdelete(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการลบ</Modal.Title>
        </Modal.Header>
        <Modal.Body align="center">{`ยืนยันการลบ${schema.buttonText || ''}`}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={(e) => {
              handleDelete(deleteId)
              setIsdelete(false)
            }}
            appearance="primary"
          >
            ลบ
          </Button>
          <Button
            onClick={(e) => {
              setIsdelete(false)
              setDeleteId('')
            }}
            appearance="subtle"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </Panel>
  )
}
